/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiOutboundInvoiceState {
  Pending = "pending",
  AwaitingTracking = "awaiting_tracking",
  Sent = "sent",
  Cancelled = "cancelled",
  Failed = "failed",
}

export function instanceOfEdiOutboundInvoiceState(value: any): boolean {
  for (const key in EdiOutboundInvoiceState) {
    if (Object.prototype.hasOwnProperty.call(EdiOutboundInvoiceState, key)) {
      if (
        EdiOutboundInvoiceState[key as keyof typeof EdiOutboundInvoiceState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiOutboundInvoiceStateFromJSON(
  json: any,
): EdiOutboundInvoiceState {
  return EdiOutboundInvoiceStateFromJSONTyped(json, false);
}

export function EdiOutboundInvoiceStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoiceState {
  return json as EdiOutboundInvoiceState;
}

export function EdiOutboundInvoiceStateToJSON(
  value?: EdiOutboundInvoiceState | null,
): any {
  return value as any;
}

export function EdiOutboundInvoiceStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoiceState {
  return value as EdiOutboundInvoiceState;
}
